/* lua.js generated code 0.3.0 */
//-----------------------------------------------------------------------
//  Class include: DefaultResponseHandler, HttpBase
//-----------------------------------------------------------------------
require("hecore/rpc")
require("clover/utils/Api")
require("hecore/EventDispatcher")
require("clover/config/NetworkConfig")
require("clover/const/GameErrorCode")
require("clover/data/UserManager")
require("clover/data/FriendManager")
require("clover/config/LevelType")
require("clover/net/Localhost")
// require("clover/net/CheckNetwork")
require("clover/panelBusLogic/LoadingPanelLogic")
const Event = require("hecore/EventDispatcher").Event

var http = require("clover/utils/Http")
var AppController = AppController || table()
if (__IOS) {
    AppController = oc.HeAppController
}
kHttpEndPoints = table.const(table(
    // 使用GM命令
    [1, "queryUserInOpenConsoleList", "queryUserInOpenConsoleList"],
    [1, "login", "login"],
    [1, "getUser", "getUser"],
    [1, "getProps", "getProps"],
    [1, "getStarChestInfo", "getStarChestInfo"],
    [1, "friends", "friend"],
    [1, "likeUser", "likeUser"],
    [1, "activeHeadFrame", "activeHeadFrame"],
    [1, "getLevelScoreRank", "getLevelScoreRank"],
    [1, "getLevelTop", "getLevelTop"],
    [1, "getUnLockFriend", "getUnLockFriend"],
    [1, "queryUser", "queryUser"],
    [1, "queryUidByPhones", "queryUidByPhones"],
    [1, "requestFriend", "requestFriend"],
    [1, "getFriends", "getFriends"],
    [1, "startLadyBugTask", "startLadyBugTask"],
    [1, "endLadyBugTask", "endLadyBugTask"],
    [1, "finishChildLadyBugTask", "finishChildLadyBugTask"],
    [1, "getInviteFriendsInfo", "getInviteFriendsInfo"],
    [1, "updateUserGuideStep", "updateUserGuideStep"],
    [1, "respRequest", "respRequest"],
    [1, "newUserEnergy", "newUserEnergy"],
    [1, "getLeftAskInfos", "getLeftAskInfos"],
    [1, "getRequestNum", "getRequestNum"],
    [1, "getRequestInfos", "getRequestInfos"],
    [1, "ignoreFreegift", "ignoreFreegift"],
    [1, "getMsgList", "getMsgList"],
    [1, "getSysMsgList", "getSysMsgList"],
    [1, "getWantFreeGiftInfos", "getWantFreeGiftInfos"],
    [1, "getCouponList", "getCouponList"],
    [1, "getNearby", "getNearby"],
    [1, "getNearbyV2", "getNearbyV2"],
    [1, "sendLocation", "sendLocation"],
    [1, "getMatchs", "getMatchs"],
    [1, "confirmMatch", "confirmMatch"],
    [1, "ackMatch", "ackMatch"],
    [1, "inviteFriends", "inviteFriends"],
    [1, "queryQihooOrder", "queryQihooOrder"],
    [1, "updateConfigFromServer", "updateConfigFromServer"],
    [1, "syncSnsFriend", "syncSnsFriend"],
    [1, "getPromStatus", "getPromStatus"],
    [1, "getPromReward", "getPromReward"],
    [1, "clickProm", "clickProm"],
    [1, "getFruitsInfo", "getFruitsInfo"],
    [1, "upgradeFruitTree", "upgradeFruitTree"],
    [1, "getPassNum", "getPassNum"],
    [1, "getShareRank", "getShareRank"],
    [1, "getCompenInfo", "getCompenInfo"],
    [1, "doPaymentOrder", "doPaymentOrder"],
    [1, "doWXPaymentOrder", "doWXPaymentOrder"],
    [1, "doWXPaymentOrderV2", "doWXPaymentOrderV2"],
    [1, "doAliPaymentOrder", "doAlipayOrder"],
    [1, "doHuaweiPaymentOrder", "doHWPaymentOrder"],
    [1, "doVivoPaymentOrder", "doVivoPaymentOrder"],
    [1, "getRewards", "getRewards"],
    [1, "clickActivity", "clickActivity"],
    [1, "mergeConnect", "mergeConnect"],
    [1, "GetIAPCodeInitInfo", "iapInfo"],
    [1, "getCashLogs", "getCashLogs"],
    [1, "GetIAPExchangeCode", "getIapCode"],
    [1, "canSendLinkShowOff", "canSendLinkShowOff"],
    [1, "getShareRankWithPosition", "getShareRankWithPosition"],
    [1, "getPropsInGame", "getPropsInGame"],
    [1, "goodsConfig", "goodsConfig"],
    [1, "rankExtraInfo", "rankExtraInfo"],
    [1, "getUnlockInfo", "getUnlockInfo"],
    [1, "requestAreaHelp", "requestAreaHelp"],

    //  签到相关
    [1, "getMarkInfo", "getMark"],
    [1, "mark", "mark"],
    [1, "markV2", "markV2"],
    //  新版签到
    [1, "getMarkVersion", "getMarkVersion"],
    [1, "markV3", "markV3"],


    [1, "activityReward", "activityReward"],
    [1, "sellProps", "sellProps"],
    [1, "unlockLevelArea", "unlockLevelArea"],
    [1, "buy", "buy"],
    [1, "getLadyBugRewards", "getLadyBugRewards"],
    [1, "getInviteFriendsReward", "getInviteFriendsReward"],
    [1, "getInviteCountRewards", "getInviteCountRewards"],
    [1, "updateProfile", "updateProfile"],
    [1, "confirmInvite", "confirmInvite"],
    [1, "frdLink", "frdLink"],
    [1, "enterMainScene", "enterMainScene"],
    [1, "sendFreegift", "sendFreegift"],
    [1, "acceptFreegift", "acceptFreegift"],
    [1, "sendMsg", "sendMsg"],
    [1, "processMsg", "processMsg"],
    [1, "getExchangeCodeReward", "getExchangeCodeReward"],
    [1, "deleteFriend", "deleteFriend"],
    [1, "getInviteeReward", "getInviteeReward"],
    [1, "getUpdateReward", "getUpdateReward"],
    [1, "pickFruit", "pickFruit"],
    [1, "getCompenReward", "getCompenReward"],
    [1, "getWeekMatchData", "getWeekMatchDatas"],
    [1, "getCommonRankList", "getCommonRankList"],
    [1, "exchangeWeekMatchItems", "exchangeWeekMatchItems"],
    [1, "receiveWeekMatchRewards", "receiveWeekMatchRewards"],
    [1, "cnValentineInfo", "cnValentineInfo"],
    [1, "cnValentineExchange", "cnValentineExchange"],
    [1, "wxShare", "wxShare"],
    [1, "turnTable", "turnTable"],
    [1, "pushNotify", "pushNotify"],
    [1, "getRabbitMatchDatas", "getRabbitMatchDatas"],
    [1, "receiveRabbitMatchRewards", "receiveRabbitMatchRewards"],
    [1, "opNotify", "opNotify"],
    [1, "levelConfigUpdate", "levelConfigUpdate"],
    [1, "getSummerWeekMatchInfo", "getSummerWeekMatchInfo"],
    [1, "getSummerWeekMatchReward", "getSummerWeekMatchReward"],
    [1, "getAliIngamePayment", "aliIngame"],
    [1, "getAliPaymentUnsign", "aliUnsign"],
    [1, "getAliPaymentVerify", "aliVerify"],
    [1, "getAliPaymentSign", "aliSign"],
    [1, "getDebugReward", "getDebugReward"],
    // [1, "shakeInfo", "lotteryInfo"],
    // [1, "shakeReward", "lotteryReward"],
    // [1, "shake", "drawLottery"],
    // [1, "reShake", "redraw"],
    // [1, "shakeExchange", "lotteryExchange"],
    [1, "shake", "spinWheel"],
    [1, "shakeInfo", "wheelInfo"],
    [1, "shakeReward", "wheelReward"],
    [1, "shareWheel", "shareWheel"],
    [1, "buyWheelReset", "buyWheelReset"],
    [1, "getWheelWinners", "getWheelWinners"],
    //  更新玩家设置信息
    [1, "updateUserSetting", "updateUserSetting"],
    //  关前道具购买
    [1, "getPropsBeforeLevel", "getPropsBeforeLevel"],          //  获取关前道具信息
    [1, "propsBeforeLevelBuy", "propsBeforeLevelBuy"],          //  购买关前道具

    [1, "getMidasToken", "doYSDKPaymentOrder"],
    [1, "animalFriends", "animalFriends"],
    [1, "animalInvite", "animalInvite"],
    [1, "getShare", "getShare"],
    [1, "reportShare", "reportShare"],
    [1, "getGlobalStarRankList", "getGlobalStarRankList"],
    [1, "startLevel", "startlevel"],
    [1, "passLevel", "passLevel"],
    [1, "levelStuck", "levelStuck"],
    [1, "useProps", "useProps"],
    [1, "guideProp", "guideProp"],
    [1, "ingame", "ingame"],
    [1, "getNewUserRewards", "getNewUserRewards"],
    [1, "oneplusReward", "oneplusReward"],
    [1, "delCashLog", "delCashLog"],
    [1, "setting", "setting"],
    [1, "taskInit", "taskInit"],
    [1, "taskDone", "taskDone"],
    [1, "taskUpdate", "taskUpdate"],
    [1, "taskReward", "taskReward"],
    [1, "taskEnd", "taskEnd"],
    [1, "getStarRewards", "getStarRewards"],
    [1, "getConstellationRewards", "getConstellationRewards"],
    [1, "getStarRewardsV2", "getStarRewardsV2"],
    [1, "getConstellationRewardsV2", "getConstellationRewardsV2"],
    [1, "getStarRewardsConfig", "getStarRewardsConfig"],
    [1, "newName", "updateProfile"],
    [1, "setLevelStar", "setLevelStar"],
    [1, "startAreaBeginTime", "startAreaBeginTime"],
    [1, "fetchBetaRewards", "fetchBetaRewards"],
    [1, "getInviteFriendsRewardV2", "getInviteFriendsRewardV2"],
    [1, "Identify", "identify"],
    [1, "getOperatorActInfo", "getOperatorActInfo"],
    [1, "sendOperatorActContact", "sendOperatorActContact"],
    [1, "writeReplay", "writeReplay"],
    [1, "addFriend", "addFriend"],
    [1, "getShortcutRewards", "getShortcutRewards"],
    [1, "sendGameBarMsg", "sendGameBarMsg"],
    [1, "getWanbaGiftRewards", "getWanbaGiftRewards"],
    // [1, "getSentences", "getSentences"],
    // [1, "getTexts", "getTexts"],
    [1, "validateReplay", "validateReplay"],
    [1, "levelRestoreCancel", "levelRestoreCancel"],
    [1, "sendGift2Stranger", "sendGift2Stranger"],
    [1, "getDailyShareReward", "getDailyShareReward"],
    [1, "sendStrangersMsgs", "sendStrangersMsgs"],
    [1, "getShortcutEnterRewards", "getShortcutEnterRewards"],
    [1, "batchTaskDone", "batchTaskDone"],
    [1, "getRefreshStarInfo", "getRefreshStarInfo"],
    [1, "createRefreshStarTeam", "createRefreshStarTeam"],
    [1, "joinRefreshStarTeam", "joinRefreshStarTeam"],
    [1, "getRefreshStarReward", "getRefreshStarRewards"],
    [1, "kickoutRefreshStarTeam", "kickoutRefreshStarTeam"],
    [1, "renameRefreshStarTeam", "renameRefreshStarTeam"],
    [1, "geoAreaCode", "geoAreaCode"],
    [1, "wmInfo", "wmInfo"],
    [1, "wmHelp", "wmHelp"],  //周赛新wx专属分享
    [1, "wmReward", "wmReward"],
    [1, "userDetail", "userDetail"],
    [1, "wmRank", "wmRank"],
    [1, "wmRankHistory", "wmRankHistory"],
    [1, "wmNear", "wmNear"],
    [1, "wmGetMyRank", "wmGetMyRank"],
    [1, "wmLuck", "wmLuck"],
    [1, "ZhimaCertify", "zhimaCertify"],
    [1, "ZhimaAppCertify", "zhimaCertifyUrl"],
    [1, "ZhimaReportCertify", "zhimaCertifyResult"],
    [1, "getLevelSeedInfo", "getLevelSeedInfo"],

    // 七日连登
    [1, "sevenDayLoginGiftBagInit", "sevenDayLoginGiftBagInit"],
    [1, "getGiftBagStates", "getGiftBagStates"], // 查询礼包状态
    [1, "valideGiftBag", "valideGiftBag"],

    [1, "createWantedTask", "createOR"],
    [1, "takeWantedTask", "takeOR"],
    [1, "fetchWantedTaskReward", "fetchORRewards"],
    [1, "cancelWantedTask", "cancelOR"],
    [1, "wantedTaskInfo", "getORList"],
    [1, "getTargetWantedTaskRank", "getCurrentRank"],

    // 分享邀请当日次数检查和领奖
    [1, "shareInviteCheck", "shareInviteCheck"],
    [1, "getShareInviteRewards", "getShareInviteRewards"],
    [1, "publisherFetchRetCash", "orSendBackCash"],
    [1, "publisherFetchWantedReward", "awardPrize"],
    //设置空间背景
    [1, "coverInfo", "coverInfo"],
    [1, "fetchCoverRewards", "fetchCoverRewards"],

    // 特惠商城
    [1, "dmInfo", "dmInfo"],
    [1, "dmBuy", "dmBuy"],

    [1, "getBoardCastInfo", "getBoardCastInfo"],

    // 查询订单支付是否完成
    [1, "queryPayLog", "queryPayLog"],

    // 查询wanba玩家的vip等级和礼包信息
    [1, "getWanbaVipLevel", "getWanbaVipLevel"],

    // 导流奖励
    [1, "fetchLeadRewards", "fetchLeadRewards"],

    // 微信小游戏支付相关
    [1, "wechatgamePaymentGetInfo", "wechatgamePaymentGetInfo"],
    [1, "wechatgamePaymentPay", "wechatgamePaymentPay"],
    [1, "createOrder", "createOrder"],
    [1, "checkPayOrder", "checkPayOrder"],
    // qq轻游戏支付相关
    [1, "qqlightgamePaymentGetInfo", "qqlightgamePaymentGetInfo"],
    [1, "qqlightgamePaymentPay", "qqlightgamePaymentPay"],
    // honor快游戏支付相关
    [1, "honorQuickgamePaymentGetInfo", "honorQuickgamePaymentGetInfo"],
    // oppo快游戏支付相关
    [1, "oppoQuickgamePaymentGetInfo", "oppoQuickgamePaymentGetInfo"],
    // 百度快游戏支付相关
    [1, "baiduQuickgamePaymentGetInfo", "baiduGamePaymentGetInfo"],
    // vivo快游戏支付相关
    [1, "vivoQuickgamePaymentGetInfo", "vivoQuickgamePaymentGetInfoV2"],
    // huawei快游戏支付相关
    [1, "huaweiQuickGamePaymentGetInfo", "huaweiQuickGamePaymentGetInfo"],
    // huawei快游戏v2支付相关
    [1, "huaweiQuickGamePaymentGetInfoV2", "huaweiQuickGamePaymentGetInfoV2"],
    [1, "huaweiCheckOrder", "huaweiCheckOrder"],
    [1, "queryThirdPartyOrder", "queryThirdPartyOrder"],

    
    // 抖音小游戏支付相关
    [1, "ttlightgamePaymentGetInfoHttp", "douyinGamePaymentGetInfo"],
    [1, "ttlightgameGainVideoShareReward", "douyinGainVideoShareReward"],
    // mi快游戏支付相关
    [1, "xiaomiQuickGamePaymentGetInfo", "xiaomiQuickGamePaymentGetInfo"],
    // ks快游戏支付相关
    [1, "kuaishouGamePaymentGetInfo", "kuaishouGamePaymentGetInfo"],
    // 客服反馈
    [1, "fcSubmit", "fcSubmit"],

    // 微信小游戏群分享加五步
    [1, "add5StepWxGroupShare", "add5StepWxGroupShare"],
    [1, "add5StepWxGroupShareInfo", "add5StepWxGroupShareInfo"],
    [1, "addStepWxGroupShare", "addStepWxGroupShare"],
    [1, "addStepWxGroupShareInfo", "addStepWxGroupShareInfo"],
    [1, "addStepWxGroupShareClickShare", "addStepWxGroupShareClickShare"],
    [1, "addEnergyWxGroupShareInfo", "addEnergyWxGroupShareInfo"],
    [1, "addEnergyWxGroupShare", "addEnergyWxGroupShare"],
    [1, "canShareInHighScore", "canShareInHighScore"],
    [1, "openChest", "openChest"],
    [1, "getChestReward", "getChestReward"],
    [1, "getStarChestExtraReward", "getStarChestExtraReward"],
    [1, "starChestExtraRewardGetShareId", "starChestExtraRewardGetShareId"],
    [1, "starChestExtraRewardShareIn", "starChestExtraRewardShareIn"],
    [1, "starChestExtraRewardShareSucc", "starChestExtraRewardShareSucc"],
    [1, "getIslandInfo", "islandInfo"],
    [1, "getIslandReward", "islandGetReward"],
    [1, "canIslandGetReward", "islandCanGetReward"],
    [1, "openStarChest", "openStarChest"],
    [1, "islandSteal", "islandSteal"],
    [1, "islandHelp", "islandHelp"],

    // 点击宝箱求助链接进来时候发送
    [1, "redbagClicked", "redbagClicked"],
    [1, "getRedbagInfo", "getRedbagInfo"],
    [1, "getRedbagBigReward", "getRedbagBigReward"],
    [1, "getRedbagReward", "getRedbagReward"],
    [1, "redbagShareSuccess", "qqRedbagShareReward"],
    [1, "getQQRedbagShareId", "qqRedbagShareId"],
    [1, "redbagClickRealShare", "qqRedbagClickShare"],

    // 岛屿消息记录删除
    [1, "removeIslandMsg", "removeIslandMsg"],

    // 点击对方分享链接，对方获取加五步
    [1, "clickShareId", "clickShareId"],

    // 查看观看广告奖励
    [1, "getAdRewards", "getAdRewards"],
    // 领取观看广告奖励
    [1, "fetchAdRewards", "fetchAdRewards"],

    // 微信签到随机宝箱
    [1, "getMarkPriseWxChestInfo", "getMarkPriseWxChestInfo"],
    [1, "markPriseWxChestClick", "markPriseWxChestClick"],
    [1, "markPriseWxChest", "markPriseWxChest"],
    [1, "kMarkPriseWxChestClickAction", "kMarkPriseWxChestClickAction"],
    [1, "kAddStepVideo", "addStepVideo"],

    // 上报设备系统信息到服务端
    [1, "saveDeviceSystemInfo", "saveDeviceSystemInfo"],

    // 一步闯关活动
    [1, "oneStepActivityInfo", "onePassGetInfo"],
    [1, "oneStepGetShareId", "onePassGetShareId"],
    [1, "oneStepGetReward", "onePassReward"],
    [1, "oneStepStartLevel", "onePassStart"],
    [1, "oneStepHelpAddTimes", "onePassShareIn"],
    [1, "oneStepWatchVideo", "onePassWatchVideo"],

    // 限时活动
    [1, "timeModeActivityInfo", "timeMatchGetInfo"],
    [1, "timeModeGetShareId", "timeMatchGetShareId"],
    [1, "timeModeGetReward", "timeMatchReward"],
    [1, "timeModeStartLevel", "timeMatchStart"],
    [1, "timeModeHelpAddTimes", "timeMatchShareIn"],
    [1, "timeModeWatchVideo", "timeMatchWatchVideo"],   //  看视频增加挑战次数
    [1, "timeMatchWatchAd", "timeMatchWatchAd"],        //  看视频增加时间
    [1, "timeModeShareInfo", "timeMatchShare"],         //  分享配置
    [1, "timeModeShareSucc", "timeMatchShareSucc"],     //  分享成功

    [1, "coinMatchActivityInfo", "coinMatchInfo"],
    [1, "coinMatchHelpAddTimes", "coinMatchClickShare"],
    [1, "coinMatchPassLevel", "coinMatchPassLevel"],
    [1, "coinMatchGetReward", "coinMatchGetReward"],
    [1, "coinMatchInvitedInfo", "coinMatchInvited"],
    [1, "coinMatchActivityReset", "coinMatchReset"],
    [1, "coinMatchGetStepWatchAd", "coinMatchGetStepWatchAd"],
    [1, "timeMatchAddTimeGetShareId", "timeMatchAddTimeGetShareId"],
    [1, "timeMatchAddTimeShareClick", "timeMatchAddTimeShareClick"],
    [1, "timeMatchAddTimeCheck", "timeMatchAddTimeCheck"],

    // 微信一元礼包点连接到进入
    [1, "wxYiYuanGiftShareIn", "wxYiYuanGiftShareIn"],
    // 领取微信一元礼包
    [1, "fetchWxYiYuanGift", "fetchWxYiYuanGift"],

    // 金币嘉年华接口
    [1, "goldMatchActivityInfo", "goldMatchGetInfo"],
    [1, "goldMatchHelpAddTimes", "goldMatchShareIn"],
    [1, "goldMatchStartLevel", "goldMatchStart"],
    [1, "goldMatchGetReward", "goldMatchReward"],
    [1, "goldMatchWatchAd", "goldMatchWatchAd"],
    [1, "goldMatchGetShareId", "goldMatchGetShareId"],
    [1, "goldMatchShareClick", "goldMatchShareClick"],
    [1, "goldMatchShareInfo", "goldMatchShareInfo"],
    [1, "goldMatchClosePanel", "goldMatchClosePanel"],
    //失败分享后关闭界面用
    [1, "addStepWxGroupShareClose", "addStepWxGroupShareClose"],

    [1, "addContactInfo", "contact"],

    //限时礼包
    [1, "timeLimitGiftInfo", "getTimeLimitGiftInfo"],
    [1, "timeLimitGiftClickShare", "timeLimitGiftClickShare"],
    [1, "acceptTimeLimitShareReward", "acceptTimeLimitShareReward"],

    // Gacha 摇一摇 活动
    [1, "getGachaInfo", "getGachaInfo"],
    [1, "gachaTicketWatchAd", "gachaTicketWatchAd"],
    [1, "gachaGetShareId", "gachaGetShareId"],
    [1, "gachaClickShare", "gachaClickShare"],
    [1, "gachaReward", "gachaReward"],
    [1, "gachaExtraReward", "gachaExtraReward"],
    [1, "gachaDrawCash", "gachaDrawCash"],

    //用户一元礼包邀请信息
    [1, "userExtend", "userExtend"],

    // 攻略
    [1, "levelStrategyWatchAd", "levelStrategyWatchAd"],
    [1, "writeStrategyReplay", "writeStrategyReplay"],
    [1, "getUserStrategyInfo", "getUserStrategyInfo"],
    [1, "clickStrategyShare", "clickStrategyShare"],
    [1, "levelStrategyShare", "levelStrategyShare"],

    //风车币不足
    [1, "getAdRewards", "getAdRewards"],
    [1, "fetchHelpRewards", "fetchHelpRewards"],
    [1, "happycoinGetShareId", "happycoinGetShareId"],
    [1, "happycoinShareClick", "happycoinShareClick"],
    [1, "shareInfoList", "shareInfoList"],

    //  银币不足
    [1, "getObtainCoinWay", "getObtainCoinWay"],
    [1, "addCoinByVideo", "addCoinByVideo"],
    [1, "addCoinGetShareId", "addCoinGetShareId"],
    [1, "addCoinClickShareIn", "addCoinClickShareIn"],

    //关末加步数优化
    [1, "addStepLevelEndInfo", "addStepLevelEndInfo"],
    [1, "addStepLevelEndSendShare", "addStepLevelEndSendShare"],
    [1, "addStepLevelEndShareQuery", "addStepLevelEndShareQuery"],
    [1, "addStepLevelEndBuyStep", "addStepLevelEndBuyStep"],
    [1, "addStepUpgradeBuy", "addStepUpgradeBuy"],

    //主线求超越
    [1, "getPassLevelShowOffConfig", "getPassLevelShowOffConfig"],
    [1, "getPassLevelShowOffInfo", "getPassLevelShowOffInfo"],
    [1, "passLevelShowOffSucc", "passLevelShowOffSucc"],


    /**
     * 获取收藏有礼奖励
     */
    [1, "getOppoCollectReward", "getOppoCollectReward"],
    /**
     * 礼包功能
     */
    [1, "levelEndGiftbagInfo", "levelEndGiftbagInfo"],
    [1, "levelEndGiftbagShow", "levelEndGiftbagShow"],
    [1, "marketGiftBagShow", "marketGiftBagShow"],
    [1, "levelEndGiftbagGet", "fetchLevelEndShareGift"],
    [1, "levelEndShareGiftClick", "levelEndShareGiftClick"],
    [1, "levelEndShareGiftGetShareId", "levelEndShareGiftGetShareId"],
    [1, "levelEndShareGiftQuery", "levelEndShareGiftQuery"],

    /**
     * 商店功能
     */
    [1, "getMarketInfo", "getMarketInfo"],

    //授权接口
    [1, "authorize", "authorize"],

    // 百度2019暑假活动
    [1, "baiduGameReport", "baiduGameReport"],
    [1, "baiduGameInfo", "baiduGameInfo"],

    //屏蔽ip相关
    [1, "ipRegionStatus", "ipRegionStatus"],
    [1, "saveIpRegionStatus", "saveIpRegionStatus"],
    [1, "getInviteNewCount", "getInviteNewCount"],

    [1, "prizePromotion", "prizePromotion"],

    // pvp
    [1, "getPvpInfo", "getPvpInfo"],
    [1, "pvpRankList", "pvpRankList"],
    [1, "pvpReportList", "pvpReportList"],
    [1, "gainReportReward", "gainReportReward"],
    [1, "pvpConsume", "pvpConsume"],
    [1, "gainScoreReward", "gainScoreReward"],
    [1, "gainPvpAdCount", "gainPvpAdCount"],
    [1, "friendPvpInviteinfo", "friendPvpInviteinfo"],
    [1, "friendPvpCheckRewardExpire", "friendPvpCheckRewardExpire"],
    [1, "friendPvpMatch", "friendPvpMatch"],
    [1, "friendPvpMatchCancel", "friendPvpMatchCancel"],
    [1, "friendPvpRobot", "friendPvpRobot"],
    [1, "pvpResult", "pvpResult"],
    [1, "rankUserInfo", "rankUserInfo"],

    //订阅
    [1, "subscribeMessage", "subscribe"],

    // 格子广告
    [1, "getGridBannerCondition", "getGridBannerCondition"],
    [1, "saveShowVideo", "saveShowVideo"],

    //  互动邀请
    [1, "getInteractiveInfo", "getFriendsHelpEachOtherReward"],
    [1, "addProgressReward", "addProgressReward"],
    [1, "fetchInteractiveReward", "fetchFriendsHelpEachOtherReward"],
    [1, "fetchFriendsHelpEachOtherProgressReward", "fetchFriendsHelpEachOtherProgressReward"],

    // 插屏广告
    [1, "saveInterAd", "saveInterAd"],
    [1, "getInterAd", "getInterAd"],

    // 星星抽奖
    [1, "getStarRewardPool", "getStarRewardPool"],
    [1, "getStarRewardCashMsg", "getStarRewardCashMsg"],
    [1, "doStarRewardDraw", "doStarRewardDraw"],
    [1, "doStarRewardReflesh", "doStarRewardReflesh"],
    [1, "doStarRewardInvite", "doStarRewardInvite"],
    [1, "doStarRewardAd", "doStarRewardAd"],
    [1, "doStarRewardShare", "doStarRewardShare"],
    [1, "getStarRewardShareId", "getStarRewardShareId"],
    [1, "getStarChestInfo", "getStarChestInfo"],
    [1, "showStarRewardDraw", "showStarRewardDraw"],

    //  主线关双倍奖励
    [1, "getLevelBonusReward", "getLevelBonusReward"],
    [1, "levelBonusShareIn", "levelBonusShareIn"],

    // 新排行
    [1, "getNewRankInfo", "getNewRankInfo"],    // 获取新排行榜首页展示信息（全国榜和地区榜）
    [1, "getFriendNewRankInfo", "getFriendNewRankInfo"],    // 获取新排行榜好友榜首页展示信息
    [1, "getNewRankList", "getNewRankList"],    // 获取新排行榜数据（全国榜和地区榜）
    [1, "getFriendNewRankList", "getFriendNewRankList"],    // 获取新排行榜好友榜数据
    [1, "getNewRankRecommendedFriends", "getNewRankRecommendedFriends"],    // 获取用户新排行榜系统推荐好友
    [1, "addNewRankRecommendedFriend", "addNewRankRecommendedFriend"], // 加推荐好友
    [1, "fetchNewRankProgressReward", "fetchNewRankProgressReward"],    // 领取新排行榜进度奖励,
    [1, "gatherUserAreaCode", "gatherUserAreaCode"],    // 收集用户地区码
    [1, "fetchNewRankFriendReward", "fetchNewRankFriendReward"],    // 针对微信感兴趣好友，登录时发奖

    //  岛屿解锁
    [1, "getIslandUnlockInfo", "islandUnlockInfo"],             //  获取岛屿解锁信息
    [1, "islandUnlockAdTime", "islandUnlockAdTime"],            //  岛屿解锁看广告加速
    [1, "clickIslandUnlockShareTime", "islandUnlockShareTime"], //  点击加速解锁分享
    [1, "getIslandUnlockShareId", "islandUnlockShareId"],       //  获取帮助解锁分享ID
    [1, "islandUnlockClickShare", "islandUnlockClickShare"],    //  点击帮助解锁分享链接
    [1, "islandUnlock", "islandUnlock"],                        //  岛屿解锁
    [1, "getIslandSuccShareId", "islandShareId"],               //  获取解锁成功分享ID
    [1, "islandSuccClickShare", "islandClickShare"],            //  点击解锁成功分享链接
    [1, "getIslandShareReward", "islandShareReward"],           //  领取岛屿解锁分享奖励

    [1, "fullStarClickShare", "fullStarClickShare"],            //  点击满星分享链接
    [1, "fullStarShareReward", "fullStarShareReward"],           //  领取满星分享奖励

    // 关前道具广告
    [1, "propsBeforeLevelAd", "propsBeforeLevelAd"],    // 获取关前道具看广告信息

    // AI礼包相关
    [1, "getAiGiftBagInfo", "getAiGiftBagInfo"],  // 获取AI每日特惠礼包
    [1, "checkAiGiftBagBuy", "checkAiGiftBagBuy"],  // 检查礼包购买资格
    [1, "getAiGroupTestInfo", "getAiGroupTestInfo"],    // 获取AI礼包分组信息
    [1, "gatherUserAiInfo", "gatherUserAiInfo"],    // 收集玩家ai礼包实时特征值

    // 道具广告
    [1, "getAdGambleInfo", "getAdGambleInfo"],  // 获取金币转转转信息
    [1, "adGambleDraw", "adGambleDraw"],  // 金币转转转抽奖
    [1, "getAdGambleReward", "getAdGambleReward"],  // 领取金币转转转奖励
    [1, "saveGoldModeAd", "saveGoldModeAd"],  // 记录看风车币类型广告

    // 召回
    [1, "fetchBackReward", "fetchBackReward"],  // 领取回归奖励

    // 存钱罐
    [1, "getMoneyBoxInfo", "getMoneyBoxInfo"],  // 获取存钱罐信息
    [1, "checkMoneyBoxBuy", "checkMoneyBoxBuy"],  // 存钱罐购买校验
    [1, "moneyBoxCancel", "moneyBoxCancel"],  // 存钱罐取消订单
    [1, "queryOrder", "queryOrder"],  // 查询正在进行中的订单是否完成
    [1, "getMoneyBoxProductId", "getMoneyBoxProductId"],  // 获取存钱罐产品ProductId

    // 补星二期
    [1, "getIslandRewards", "getIslandRewards"],//获取海岛奖励信息（补星二期新增）
    [1, "fetchIslandRewards", "fetchIslandRewards"],//领取取海岛奖励信息（补星二期新增）

    [1, "wanbaCheckOrder", "wanbaCheckOrder"], // 玩吧下单校验


    // 海滨之星
    [1, "coastStarInfo", "coastStarInfo"],//获取海滨之星活动信息
    [1, "coastStarRank", "coastStarRank"],//获取海滨之星排行榜列表
    [1, "coastStarFetchReward", "coastStarFetchReward"],//海滨之星领取进度奖励
    [1, "coastStarBonus", "coastStarBonus"],//海滨之星翻倍
    [1, "coastStarGetShareId", "coastStarGetShareId"],//获取海滨之星活动分享链接id
    [1, "coastStarShareClick", "coastStarShareClick"],//海滨之星点击分享链接

    //广告优化一期获取广告信息
    [1, "getAdInfo", "getAdInfo"],
    [1, "fetchAdReward", "fetchAdReward"],

    // 手动定位
    [1, "chooseUserLocation", "chooseUserLocation"],
    // 账号删除
    [1, "deleteAccount", "deleteAccount"],
    [1, "fetchFillStarReward", "fetchFillStarReward"],//领取免费每日补星奖励
    //冠军赛
    [1, "championInfo", "championInfo"],
    [1, "championRewardFetch", "championRewardFetch"],
    //广告任务
    [1, "getAdTaskInfo", "getAdTaskInfo"],
    [1, "finishAdTask", "finishAdTask"],
    [1, "fetchAdTaskReward", "fetchAdTaskReward"],
    //通行证
    [1, "getEnergy", "getEnergy"],
    [1, "battlePassInfo", "battlePassInfo"],
    [1, "battlePassRewardFetch", "battlePassRewardFetch"],
    [1, "battlePassBannerShow", "battlePassBannerShow"],
    [1, "battlePassBannerInfo", "battlePassBannerInfo"],
    // 限时闯关
    [1, "rushLimitInfo", "rushLimitInfo"],//获取活动详情数据
    [1, "rushLimitJoin", "rushLimitJoin"],//报名
    [1, "rushLimitRewardFetch", "rushLimitRewardFetch"],//领奖
    [1, "rushLimitRobotGrow", "rushLimitRobotGrow"],//触发机器人成长
    [1, "rushLimitGetShareId", "rushLimitGetShareId"],//获取分享id
    [1, "rushLimitShareClick", "rushLimitShareClick"],//点击分享链接
    // 新手任务
    [1, "getNewUserTaskInfo", "getNewUserTaskInfo"],//获取新手任务信息
    [1, "finishNewUserTask", "finishNewUserTask"],//完成新手任务
    [1, "fetchNewUserTaskReward", "fetchNewUserTaskReward"],//领取新手任务奖励
    [1, "updateDropData", "updateDropData"],
    [1, "getDropData", "getDropData"],


    [1, "cubeAbTest", "cubeAbTest"],//cube分组
    //周年庆
    [1, "anniversaryInfo", "anniversaryInfo"],
    [1, "anniversaryWarmUp", "anniversaryWarmUp"],
    [1, "anniversaryFetchReward", "anniversaryFetchReward"],
    [1, "anniversaryExchangeReward", "anniversaryExchangeReward"],
    [1, "anniversaryExchangeRecord", "anniversaryExchangeRecord"],
    [1, "updateContactInfo", "updateContactInfo"],
    [1, "anniversaryExchangeLottery", "anniversaryExchangeLottery"],
    // [1, "anniversaryBattlePassInfo", "anniversaryBattlePassInfo"],
    // 神秘商店
    [1, "getSecretShopInfo", "getSecretShopInfo"],
    [1, "chooseSecretShopDiscount", "chooseSecretShopDiscount"],
    [1, "checkSecretShopBuy", "checkSecretShopBuy"],

    //造船
    [1, "shipDetailLite", "shipDetailLite"],
    [1, "shipDetail", "shipDetail"],
    [1, "shipNewbieGuideStep", "shipNewbieGuideStep"],
    [1, "shipGlobalRank", "shipGlobalRank"],
    [1, "shipGlobalRankRewardFetch", "shipGlobalRankRewardFetch"],
    [1, "shipCaptainRewardFetch", "shipCaptainRewardFetch"],
    [1, "shipChestRewardFetch", "shipChestRewardFetch"],
    [1, "shipMemberRevive", "shipMemberRevive"],
    [1, "shipAdRevive", "shipAdRevive"],
    [1, "shipCollectUnitReady", "shipCollectUnitReady"],
    // 神秘岛
    [1, "mysteriousIslandRank", "mysteriousIslandRank"],
    [1, "mysteriousIslandExhibition", "mysteriousIslandExhibition"],
    [1, "mysteriousIslandLike", "mysteriousIslandLike"],
    // 晋级赛
    [1, "qualifyingInfo", "qualifyingInfo"],
    [1, "qualifyingJoin", "qualifyingJoin"],
    [1, "qualifyingGetShareId", "qualifyingGetShareId"],
    [1, "qualifyingShareClick", "qualifyingShareClick"],
    [1, "qualifyingWatchAd", "qualifyingWatchAd"],
    [1, "qualifyingFetchReward", "qualifyingFetchReward"],
    [1, "qualifyingGuide", "qualifyingGuide"],

    //星岛
    [1, "starDreamInfo", "starDreamInfo"],
    [1, "starDreamBuild", "starDreamBuild"],
    [1, "starDreamWatchAd", "starDreamWatchAd"],
    [1, "starDreamGetShareId", "starDreamGetShareId"],
    [1, "starDreamShareClick", "starDreamShareClick"],
    [1, "starDreamShareInfo", "starDreamShareInfo"],
    [1, "starDreamFetchReward", "starDreamFetchReward"],

    [1, "getWxGift", "getWxGift"],
    // 兑换码
    [1, "getCdKeyReward", "getCdKeyReward"],
    // 新手奖励
    [1, "beginnerGiftFetchReward", "beginnerGiftFetchReward"],
    //无尽宝箱
    [1, "getEndlessTreasureInfo", "endlessTreasureInfo"],
    [1, "getEndlessTreasureFetchReward", "endlessTreasureFetchReward"],
    // 主线收集
    [1, "levelCollectionInfo", "levelCollectionInfo"],
    //快艇大赛
    [1, "speedboatMatchInfo", "speedboatMatchInfo"],
    [1, "speedboatMatchJoin", "speedboatMatchJoin"],
    [1, "speedboatMatchRewardFetch", "speedboatMatchRewardFetch"],
    // 月票
    [1, "monthCardInfo", "monthCardInfo"],
    [1, "monthCardFetchReward", "monthCardFetchReward"],
    // 新商城
    [1, "shopInfo", "shopInfo"],
    [1, "shopFreeBuy", "shopFreeBuy"],
    [1, "shopRefresh", "shopRefresh"],
    // 商城新春礼包购买校验
    [1, "checkSpringPackBuy", "checkSpringPackBuy"],

    //海岛礼包
    [1, "islandTreasureInfo", "islandTreasureInfo"],
    [1, "islandTreasureFetchReward", "islandTreasureFetchReward"],
    // 抖音侧边栏
    [1, "douyinSideRewardsDetail", "douyinSideRewardsDetail"],
    [1, "douyinSideRewardsFetch", "douyinSideRewardsFetch"],
    [1, "douyinRecommendCardRewardFetch", "douyinRecommendCardRewardFetch"],
    // 贴贴
    [1, "stickerBattleInfo", "stickerBattleInfo"],
    [1, "stickerBattleJoin", "stickerBattleJoin"],
    [1, "stickerBattleBook", "stickerBattleBook"],
    [1, "getUserProfileInfo", "getUserProfileInfo"],
    // 贴贴新版接口
    [1, "oceanPartyInfo", "oceanPartyInfo"],
    [1, "oceanPartyFetchReward", "oceanPartyFetchReward"],

    

    //摘椰子
    [1, "balloonRiseDetail", "balloonRiseDetail"],
    [1, "balloonRiseNodeRewardFetch", "balloonRiseNodeRewardFetch"],

    // 精力礼包信息 banner用
    [1, "energyPackInfo", "energyPackInfo"],
    [1, "goldElysiumInfo", "goldElysiumInfo"],
    // replay
    [1, "writeStartLevelReplay", "writeStartLevelReplay"],
    //钓鱼大赛
    [1, "fishingInfo", "fishingInfo"],
    [1, "fishingJoin", "fishingJoin"],
    [1, "fishingCast", "fishingCast"],
    [1, "fishingGetShareId", "fishingGetShareId"],
    [1, "fishingShareClick", "fishingShareClick"],
    [1, "fishingFetchReward", "fishingFetchReward"],
    [1, "fishingGuide", "fishingGuide"],
    // 限定礼包
    [1, "getLiveGiftBagInfo", "getLiveGiftBagInfo"],
    // 装扮信息
    [1, "getDressInfo", "getDressInfo"],
    [1, "changeDress", "changeDress"],
    //勋章排行榜
    [1, "getLevelScoreRankInfo", "getLevelScoreRankInfo"],
    [1, "getLevelScoreRankList", "getLevelScoreRankList"],
    [1, "weekRankDetail", "weekRankDetail"],
    [1, "weekRankList", "weekRankList"],
    [1, "weekRankRewardFetch", "weekRankRewardFetch"],
    [1, "weekRankCupList", "weekRankCupList"],
    //解码特工
    [1, "magicCodeDetail", "magicCodeDetail"],
    [1, "magicCodePlay", "magicCodePlay"],
    [1, "magicCodeSettleRewardFetch", "magicCodeSettleRewardFetch"],
    
    // 获取玩家分数信息
    [1, "getUserScoreInfo", "getUserScoreInfo"],

    //马戏团
    [1, "circusInfo", "circusInfo"],
    [1, "circusSpin", "circusSpin"],
    //挖宝石
    [1, "coffeeLotCookingInfo", "coffeeLotCookingInfo"],
    [1, "coffeeLotCookingShovel", "coffeeLotCookingShovel"],
    //投篮王牌
    [1, "dunkAceDetail", "dunkAceDetail"],
    [1, "dunkAceJoin", "dunkAceJoin"],
    [1, "dunkAceRewardFetch", "dunkAceRewardFetch"],
    //关卡崩溃上报
    [1, "levelCrash", "levelCrash"],
    //水上乐斗
    [1, "waterFightingDetail", "waterFightingDetail"],
    [1, "waterFightingJoin", "waterFightingJoin"],
    [1, "waterFightingRewardFetch", "waterFightingRewardFetch"],
    [1, "waterFightingRecords", "waterFightingRecords"],
    [1, "waterFightingHpRecover", "waterFightingHpRecover"],
    //三选一礼包
    [1, "trinityGiftBagDetail", "trinityGiftBagDetail"],
    [1, "trinityGiftBagBuyCheck", "trinityGiftBagBuyCheck"],
    
    //超鸟
    [1, "superMagicBirdInfo", "superMagicBirdInfo"],
    [1, "superMagicBirdGuide", "superMagicBirdGuide"],
    [1, "superMagicBirdLevelPanelGuide", "superMagicBirdLevelPanelGuide"],

    //俄罗斯方块
    [1, "tetrisDetail", "tetrisDetail"],
    [1, "tetrisLevelUp", "tetrisLevelUp"],
    [1, "tetrisSettle", "tetrisSettle"],

    //信件
    [1, "mailList", "mailList"],
    [1, "mailOpen", "mailOpen"],
    [1, "mailAccept", "mailAccept"],
    [1, "mailDelete", "mailDelete"],
    [1, "mailBatchDelete", "mailBatchDelete"],
    [1, "mailBatchAccept", "mailBatchAccept"],

    // 救援礼包
    [1, "salvageGiftBagDetail", "salvageGiftBagDetail"],
    [1, "salvageGiftBagShow", "salvageGiftBagShow"],
    [1, "salvageGiftBagBuyCheck", "salvageGiftBagBuyCheck"],
    [1, "salvageGiftBagRewardFetch", "salvageGiftBagRewardFetch"],


    //宠物
    [1, "petStoryInfo", "petStoryInfo"],
    [1, "petStoryJoin", "petStoryJoin"],
    [1, "petStoryShareInfo", "petStoryShareInfo"],
    [1, "petStoryInvite", "petStoryInvite"],
    [1, "petStoryPetInfo", "petStoryPetInfo"],
    [1, "petStoryWalk", "petStoryWalk"],
    [1, "petStorySkipGuide", "petStorySkipGuide"],
    [1, "petStoryFetchReward", "petStoryFetchReward"],
    [1, "petStoryGetShareId", "petStoryGetShareId"],
    [1, "petStoryShareClick", "petStoryShareClick"],
    //
    [1, "userProfileLike", "userProfileLike"],
    [1, "userProfileShow", "userProfileShow"],
    //福利中心icon引导
    [1, "starRewardGuide", "starRewardGuide"],
    [1, "pvpGuide", "pvpGuide"],
    
))

var DefaultResponseHandler = xClass("DefaultResponseHandler")
DefaultResponseHandler.prototype.ctor = function (endpoints, errors) {
    var self = this
    self.endpoints = endpoints
    self.errors = errors
}
DefaultResponseHandler.prototype.handleError = function (endpoints, err) {
    var self = this
    he_log_warning("default handleError, err: " + err + ", endpoints: " + table.tostring(endpoints))
}
DefaultResponseHandler.prototype.handleResponse = function (endpoint, data) {
    var self = this
    he_log_info("default handleResponse for " + endpoint)
}
var isAlerted = false
ConnectionManager = xClass("ConnectionManager")
var loader = ConnectionManager.new()
var isConnectionManagerInitialized = 0
ConnectionManager.prototype.reset = function (userId, sessionKey) {
    var self = this
    if (isConnectionManagerInitialized === 0) {
        isConnectionManagerInitialized = 1
        ConnectionManager.initialize(userId, sessionKey)
    } else {
        ConnectionManager.changeUserID(userId, sessionKey)
    }
}
ConnectionManager.prototype.initialize = function (uid, sessionKey) {
    var self = this
    assert(uid && sessionKey, "uid and sessionKey should not be nil")
    var appId = he.StartupConfig.getInstance().getGspAppId()
    var language = "zh_CN"
    var pf = he.StartupConfig.getInstance().getPlatformName()
    if (!pf) {
        pf = "hex"
    }
    if (__IOS_FB) {
        language = "zh_TW"
    }
    var timeout = 2
    var config = table(
        [1, "url", NetworkConfig.rpcURL],
        [1, "queueSize", 10],
        [1, "flushInterval", 10],
        [1, "timeout", timeout],
        [1, "defaultPriority", rpc.SendingPriority.kNormal]
    )
    var sessionKeySource = function (callback) {
        callback(UserManager.getInstance().sessionKey, os.time() + 3600)
    }
    function platformFinder() {
        return pf
    } // older value "hex"
    var transponder = rpc.RpcTransponder.new(config, sessionKeySource)
    loader.transponder = transponder
    var others = table([1, "seqUDID", he.MetaInfo.getInstance().getUdid()], [1, "dcSession", GameProxy.getInstance().getDCSession()])
    var subPlatform = DcUtil.getSubPlatform() || "0"
    if (subPlatform && string.len(subPlatform) <= 30) {
        others.subPlatform = DcUtil.getSubPlatform()
    }
    transponder.registryConvertor(rpc.AssembleConvertor.new(true, _G.bundleVersion, "1.0.0", appId, language, platformFinder, 0, null, null, others), table([0, rpc.CompressConvertor.new()], [0, rpc.HeaderConvertor.new()]), table([0, rpc.PackageConvertor.new()]))
    transponder.invalidateSessionKey()
    transponder.changeUID(uid)
    function handleError(self, endpoints, err, requests) {
        ConnectionManager.handleError(endpoints, err, requests)
    }
    var errors = table()
    errors[108] = "skCheckError"
    transponder.registryHandler(table([1, "errors", errors], [1, "handleError", handleError]))
    if (!transponder.isBlocked()) {
        transponder.flush()
    }
}
ConnectionManager.prototype.invalidateSessionKey = function () {
    var self = this
    var transponder = loader.transponder
    transponder.invalidateSessionKey()
}
ConnectionManager.prototype.changeUserID = function (uid, sessionKey) {
    var self = this
    var transponder = loader.transponder
    transponder.invalidateSessionKey()
    transponder.changeUID(uid)
}
var syncLock = false
ConnectionManager.prototype.block = function () {
    var self = this
    if (loader.transponder) {
        loader.transponder.block()
    }
}
ConnectionManager.prototype.flush = function () {
    var self = this
    if (!syncLock && loader.transponder) {
        loader.transponder.flush()
    }
}
ConnectionManager.prototype.sendRequest = function (endpoint, body, callback) {
    var self = this
    if (loader.transponder) {
        loader.transponder.call(endpoint, body, callback, rpc.SendingPriority.kHigh, false)
    }
}
ConnectionManager.prototype.syncBlock = function () {
    var self = this
    syncLock = true
    ConnectionManager.block()
}
ConnectionManager.prototype.syncFlush = function () {
    var self = this
    syncLock = false
    ConnectionManager.flush()
}
ConnectionManager.prototype.handleError = function (endpoints, err, requests) {
    var self = this
    if (err && tonumber(err) === ZooErrorCode.kSessionKeyInvalid) {
        if (isAlerted) {
            return false
        }
        var title = getText("error.tip.108")
        var okLabel = getText("update.done.confirm")
        function onUIAlertViewCallback(flag) {
            cc.log("ios show alert 108 callback")
            isAlerted = false
            Localhost.getInstance().clearLastLoginUserData()
            GameProxy.getInstance().exitGame()
        }
        isAlerted = true
        GameProxy.getInstance().alert("", title, onUIAlertViewCallback, okLabel, null)
        return true
    }
    return false
}

// HttpBase ---------------------------------------------------------
HttpBase = xClass("HttpBase", EventDispatcher)
HttpBase.prototype.ctor = function (showLoadingAnim) {
    var self = this
    EventDispatcher.prototype.ctor.call(self)
    self.loadingId = null
    self.isResponsed = false
    self.headers = null
    self.showLoadingAnim = showLoadingAnim
    var transponder = {}
    transponder.call = function (endpoint, data, handler) {
        var callback = {}
        callback.handler = handler;
        callback.onFail = function (err) {
            self.onLoadingError(err)
        }
        callback.onTimeOut = function (err) {
            self.onTimeOut(err)
        }
        let url = ''
        if (endpoint !== ApiList.H5Login) {
            url = http.host + "?uid=" + UserManager.getInstance().uid + "&" + http.hostQuery
        } else {
            url = http.loginHost + "?" + http.hostQuery
        }
        http.load(url, endpoint, data, callback, null, self.headers);
    }
    self.transponder = transponder
}
HttpBase.prototype.dispose = function () {
    var self = this
    if (self.loadingId) {
        LoadingPanelLogic.getInstance().remove(self.loadingId)
        self.loadingId = null
    }
}
HttpBase.prototype.onCancel = function () {
    var self = this
    if (self.loadingId) {
        LoadingPanelLogic.getInstance().remove(self.loadingId)
        self.loadingId = null
    }
    if (!self.isResponsed) {
        self.isResponsed = true
        self.dispatchEvent(Event.new(Events.kCancel, table(), self))
    }
}
// 已过时：即将删除
HttpBase.prototype.syncLoad = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    // if not kUserLogin then return self:onLoadingError(ZooErrorCode.kNotLoginError) end
    var para = table([2, __VA_ARG])
    self.load(...unpack(para))
}
//该方法用于修复完异常数据后，继续正常的http请求
HttpBase.prototype.syncLoad2 = function () {
    var __VA_ARG = $slice(arguments, 0)
    var self = this
    if (!kUserLogin) {
        // WARN: maybe multi result
        return self.onLoadingError(ZooErrorCode.kNotLoginError)
    }
    var para = table([2, __VA_ARG])
    function onSyncError(err) {
        self.onLoadingError(err)
    }
    function onSyncFinished() {
        self.load(...unpack(para))
    }
    SyncManager.getInstance().sync(onSyncFinished, onSyncError, kRequireNetworkAlertAnimation.kNone)
}
HttpBase.prototype.onLoadingComplete = function (data) {
    var self = this
    self.dispatchEvent(Event.new(Events.kComplete, data, self))
}
HttpBase.prototype.onLoadingError = function (err) {
    var self = this
    self.dispatchEvent(Event.new(Events.kError, err, self))
}
HttpBase.prototype.onTimeOut = function (err) {
    var self = this
    self.dispatchEvent(Event.new(Events.kError, err, self))
}
HttpBase.prototype.request = function (endpoint, data, handler, priority, isLogin, useMask) {
    var self = this
    self.handler = handler
    if (useMask) {
        showGlobalMask();
        self.addEventListener(Events.kComplete, hideGlobalMask);
        self.addEventListener(Events.kError, hideGlobalMask);
        self.addEventListener(Events.kCancel, hideGlobalMask);
    }
    self.transponder.call(endpoint, data, handler, priority, isLogin)
}
// Register ---------------------------------------------------------
RegisterHTTP = xClass("RegisterHTTP", EventDispatcher)
RegisterHTTP.prototype.load = function () {
    var self = this
    self.dispatchEvent(Event.new(Events.kComplete, "ok", self))
    // var self = this
    // var url = NetworkConfig.registerURL
    // var mac = he.MetaInfo.getInstance().getMacAddress() || ""
    // var imsi = he.MetaInfo.getInstance().getImsi() || ""
    // var imei = he.MetaInfo.getInstance().getImei() || ""
    // var idfa = ""
    // if (__IOS) {
    //     idfa = AppController.getAdvertisingIdentifier() || ""
    // }
    // var version = he.MetaInfo.getInstance().getOsVersion() || ""
    // var info = table(
    //     [1, "mac", mac],
    //     [1, "idfa", idfa],
    //     [1, "sk", kDeviceID],
    //     [1, "osver", version],
    //     [1, "cv", _G.bundleVersion],
    //     [1, "imsi", imsi],
    //     [1, "imei", imei]
    // )
    // var sign = he.HeMathUtils.ca(imsi + imei + kDeviceID + mac + idfa + version + _G.bundleVersion)
    // var infoStr = table.serialize(info)
    // var params = string.format("?info=%s&sign=%s&_v=%s", he.HeMathUtils.base64Encode(infoStr, string.len(infoStr)), sign, _G.bundleVersion)
    // url = url + params
    // cc.log("RegisterHTTP:", info.sk)
    // var request = he.HttpRequest.createGet(url)
    // var timeout = 5
    // var connection_timeout = 2
    // request.setConnectionTimeoutMs(connection_timeout * 1000)
    // request.setTimeoutMs(timeout * 1000)
    // function onRegisterFinished(response) {
    //     var headers = response.headers
    //     if (response.httpCode !== 200) {
    //         self.dispatchEvent(Event.new(Events.kError, err, self))
    //     } else {
    //         var message = response.body
    //         var json = table.deserialize(message)
    //         cc.log("register====================", table.tostring(json))
    //         if (json && json.result === "success" && json.uid && string.find(json.uid, "^%d+$")) {
    //             var kTransformedUserID = json.uid
    //             _G.kTransformedUserID = kTransformedUserID
    //             if (DCAssist && DCAssist.cacheTransferDataOnPreload && type(DCAssist.cacheTransferDataOnPreload) === "function") {
    //                 DCAssist.cacheTransferDataOnPreload(json)
    //             }
    //             GameProxy.getInstance().setUserId(tostring(kTransformedUserID))
    //             self.dispatchEvent(Event.new(Events.kComplete, json, self))
    //         } else {
    //             self.dispatchEvent(Event.new(Events.kError, err, self))
    //         }
    //     }
    // }
    // if (PrepackageUtil.isPreNoNetWork()) {
    //     self.dispatchEvent(Event.new(Events.kError, err, self))
    // } else {
    //     he.HttpClient.getInstance().sendRequest(onRegisterFinished, request)
    // }
}
// Rank ---------------------------------------------------------
RankUpdateHTTP = xClass("RankUpdateHTTP", EventDispatcher)
RankUpdateHTTP.prototype.load = function (startLevelId, endLevelId) {
    let self = this
    let mac = he.MetaInfo.getInstance().getMacAddress() || ""
    let imsi = he.MetaInfo.getInstance().getImsi() || ""
    let imei = he.MetaInfo.getInstance().getImei() || ""
    let idfa = ""
    if (__IOS) {
        idfa = AppController.getAdvertisingIdentifier() || ""
    }
    let version = he.MetaInfo.getInstance().getOsVersion() || ""
    let info = table(
        [1, "uid", tostring(UserManager.getInstance().uid)],
        [1, "startLevelId", startLevelId],
        [1, "endLevelId", endLevelId],
        [1, "p", tostring(he.StartupConfig.getInstance().getPlatformName()) || ""],
        [1, "_v", _G.bundleVersion]
    )
    let sign = he.HeMathUtils.ca(tostring(info.uid) + tostring(info.startLevelId) + tostring(info.endLevelId) + tostring(info.p) + tostring(info._v))
    let url = NetworkConfig.rankPalpitationHost + "?"
    for (let k in info) {
        let v = info[k]
        if ($null(v)) continue
        url = url + "&" + tostring(k) + "=" + v
    }
    url = url + "&" + "sign" + "=" + sign
    let request = he.HttpRequest.createGet(url)
    let timeout = 5
    let connection_timeout = 2
    request.setConnectionTimeoutMs(connection_timeout * 1000)
    request.setTimeoutMs(timeout * 1000)
    function onRegisterFinished(response) {
        let headers = response.headers
        if (response.httpCode !== 200) {
            self.dispatchEvent(Event.new(Events.kError, err, self))
        } else {
            let message = response.body
            let json = table.deserialize(message)
            if (type(json) === "table") {
                self.dispatchEvent(Event.new(Events.kComplete, table([1, "levelRanks", json]), self))
            }
        }
    }
    if (PrepackageUtil.isPreNoNetWork()) {
        self.dispatchEvent(Event.new(Events.kError, err, self))
    } else {
        he.HttpClient.getInstance().sendRequest(onRegisterFinished, request)
    }
}
// RankUpload ---------------------------------------------------------
RankUploadHTTP = xClass("RankUploadHTTP", EventDispatcher)
RankUploadHTTP.prototype.load = function (levelIds) {
    let self = this
    let mac = he.MetaInfo.getInstance().getMacAddress() || ""
    let imsi = he.MetaInfo.getInstance().getImsi() || ""
    let imei = he.MetaInfo.getInstance().getImei() || ""
    let idfa = ""
    if (__IOS) {
        idfa = AppController.getAdvertisingIdentifier() || ""
    }
    let version = he.MetaInfo.getInstance().getOsVersion() || ""
    let info = table(
        [1, "uid", tostring(UserManager.getInstance().uid)],
        [1, "level_ids", levelIds],
        [1, "p", tostring(he.StartupConfig.getInstance().getPlatformName()) || ""],
        [1, "_v", _G.bundleVersion]
    )
    let sign = he.HeMathUtils.ca(tostring(info.uid) + tostring(info.level_ids) + tostring(info.p) + tostring(info._v))
    let url = NetworkConfig.rankUploadHost + "?"
    for (let k in info) {
        let v = info[k]
        if ($null(v)) continue
        url = url + "&" + tostring(k) + "=" + v
    }
    url = url + "&" + "sign" + "=" + sign
    let request = he.HttpRequest.createGet(url)
    let timeout = 5
    let connection_timeout = 2
    request.setConnectionTimeoutMs(connection_timeout * 1000)
    request.setTimeoutMs(timeout * 1000)
    function onRegisterFinished(response) {
        let headers = response.headers
        if (response.httpCode !== 200) {
            self.dispatchEvent(Event.new(Events.kError, err, self))
        } else {
            let message = response.body
            self.dispatchEvent(Event.new(Events.kComplete, table([0, message]), self))
        }
    }
    if (PrepackageUtil.isPreNoNetWork()) {
        self.dispatchEvent(Event.new(Events.kError, err, self))
    } else {
        he.HttpClient.getInstance().sendRequest(onRegisterFinished, request)
    }
}

//查询信息
TreasureBoxGetInfoHttp = xClass("TreasureBoxGetInfoHttp", HttpBase)
TreasureBoxGetInfoHttp.prototype.load = function () {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("TreasureBoxGetInfoHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("TreasureBoxGetInfoHttp success !")
            context.onLoadingComplete(data)
        }
    }
    var param = {
        createTime: 1111,
        inviteCode: 1086
    }
    param = {}
    self.request(kHttpEndPoints.getRedbagInfo, param, loadCallback, rpc.SendingPriority.kHigh, false)
}

//领单个帮助奖
TreasureBoxGetRewardHttp = xClass("TreasureBoxGetRewardHttp", HttpBase)
TreasureBoxGetRewardHttp.prototype.load = function (itemIdx) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("TreasureBoxGetRewardHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("TreasureBoxGetRewardHttp success !")
            context.onLoadingComplete(data)
        }
    }
    var param = {
        idx: itemIdx
    }
    self.request(kHttpEndPoints.getRedbagReward, param, loadCallback, rpc.SendingPriority.kHigh, false)
}
//领大奖
TreasureBoxGetBigRewardHttp = xClass("TreasureBoxGetBigRewardHttp", HttpBase)
TreasureBoxGetBigRewardHttp.prototype.load = function () {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("TreasureBoxGetBigRewardHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("TreasureBoxGetBigRewardHttp success !")
            context.onLoadingComplete(data)
        }
    }
    var param = {}
    self.request(kHttpEndPoints.getRedbagBigReward, param, loadCallback, rpc.SendingPriority.kHigh, false)
}
//好友点击链接进来通知后端
TreasureBoxHelperHttp = xClass("TreasureBoxHelperHttp", HttpBase)
TreasureBoxHelperHttp.prototype.load = function (mtime, shareUid) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("TreasureBoxHelperHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("TreasureBoxHelperHttp success !")
            context.onLoadingComplete(data)
        }
    }
    var param = {
        redbagTime: mtime,
        inviteCode: shareUid,
        v2: true
    }
    self.request(kHttpEndPoints.redbagClicked, param, loadCallback, rpc.SendingPriority.kHigh, false)
}
//删除全部或者某一条岛屿消息记录
RemoveIslandMsgHttp = xClass("RemoveIslandMsgHttp", HttpBase)
RemoveIslandMsgHttp.prototype.load = function (msgID, isClearAll = false) {
    let self = this
    let context = self
    let loadCallback = function (endpoint, data, err) {
        if (err) {
            he_log_info("RemoveIslandMsgHttp error: " + err)
            context.onLoadingError(err)
        } else {
            he_log_info("RemoveIslandMsgHttp success !")
            context.onLoadingComplete(data)
        }
    }
    var param = {
        removeAll: isClearAll,
        id: msgID
    }
    self.request(kHttpEndPoints.removeIslandMsg, param, loadCallback, rpc.SendingPriority.kHigh, false)
}
